import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const UPDATE_CUSTOMER_ID = "UPDATE_CUSTOMER_ID";
export const UPDATE_CUSTOMER_ID_LOADING =
"UPDATE_CUSTOMER_ID_LOADING";
export const UPDATE_CUSTOMER_ID_LOADING_FAILED =
"UPDATE_CUSTOMER_ID_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const upadateCustomerLoading = ms => ({
    type: UPDATE_CUSTOMER_ID_LOADING,
    payload: ms
    });
    
    export const upadateCustomerLoadingFailed = ms => ({
    type: UPDATE_CUSTOMER_ID_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function upadateCustomer(obj) {
        const request = axios.post(
            `${process.env.REACT_APP_PROFILE}/api/v1/accountant/userData/updateUserByUserId`,obj, {
                headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
              });
    
    
    return dispatch => {

    dispatch(upadateCustomerLoading());
    request
    .then(response => {   
  
    if (response.status == 200 || response.status == 201) {
     console.log(response,"response upadateCustomer")
    dispatch({
    type: UPDATE_CUSTOMER_ID,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        upadateCustomerLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(upadateCustomerLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(upadateCustomerLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(upadateCustomerLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


